import { ReportResultState } from '../reports/reportResult/reducers'

const getReportResult = (state: any): ReportResultState =>
  state.reportsState.reportResult

export { getReportResult }
